export const TOUR_TARGETS = {
  requirements: 'planning-activities-requirements',
  navigationRail: 'planning-activities-navigation-rail',
  qualityScore: 'planning-activities-plan-quality-score',
  qualityPillars: 'planning-activities-plan-quality-pillars',
  filters: 'planning-activities-filters',
  initiativesTable: 'planning-activities-initiatives-table',
  analysisKpiTiles: 'planning-activities-dashboard-kpi-tiles',
  analysisBreakdownChart: 'planning-activities-dashboard-breakdown-chart',
  analysisCoverageChart: 'planning-activities-dashboard-coverage-chart',
  analysisHeatmap: 'planning-activities-dashboard-heatmap',
  mdfLinkageTable: 'planning-activities-mdf-linkage-table',
  mdfKpiTiles: 'planning-activities-mdf-kpi-tiles',
  mdfCharts: 'planning-activities-mdf-charts',
  longTermGoals: 'planning-activities-long-term-goals',
} as const
